export function userPermissionDefinitionsModel(result) {
  if (!result?.success || !result.data || typeof result.data !== "object") {
    throw new Error("Permission definitions are unavailable.");
  }
  const modules = Array.isArray(result.data)
    ? result.data
    : Object.entries(result.data).map(([key, module]) => ({
        ...module,
        permission_key: key,
        definitions: module?.levels,
      }));
  const keys = new Set();
  return modules.map((module) => {
    const key = module.permission_key;
    if (
      typeof key !== "string" ||
      !/^[a-z][a-z0-9_]*$/.test(key) ||
      keys.has(key) ||
      !module.permission_name ||
      !Array.isArray(module.definitions)
    ) {
      throw new Error("Invalid permission definitions.");
    }
    keys.add(key);
    const levels = new Set();
    const options = module.definitions
      .map((definition) => {
        const value = definition.level;
        if (
          !Number.isInteger(value) ||
          value < 0 ||
          levels.has(value) ||
          !definition.name
        ) {
          throw new Error("Invalid permission level.");
        }
        levels.add(value);
        return {
          value,
          text: definition.name,
          uuid: definition.uuid,
          description: definition.description || "",
        };
      })
      .sort((a, b) => a.value - b.value);
    if (!levels.has(0)) throw new Error("Missing blocked permission level.");
    return { key, name: module.permission_name, options };
  });
}

export function userPermissionSelections(modules, current = {}) {
  return Object.fromEntries(
    modules.map((module) => {
      const camelKey = module.key.replace(/_([a-z])/g, (_, letter) =>
        letter.toUpperCase(),
      );
      const level = current[module.key] ?? current[camelKey] ?? 0;
      return [
        module.key,
        module.options.find((option) => option.value === Number(level)) || null,
      ];
    }),
  );
}

export function raiseUserPermissionSelections(modules, current, defaults) {
  const selected = userPermissionSelections(modules, defaults);
  return Object.fromEntries(
    modules.map((module) => {
      const previous = current[module.key];
      const proposed = selected[module.key];
      return [
        module.key,
        proposed && previous && proposed.value <= previous.value
          ? previous
          : proposed,
      ];
    }),
  );
}
